import React from "react"
import BannerContainer from "@components/BannerContainer"
import WrapperInner from "@components/WrapperInner"
import TopTitle from "@components/TopTitle"
import AnchorButton from "@components/CTAAnchorButton"
import gridBreakpoints from "@styles/bs-modifiers/grid-breakpoints.js"
import styles from "./BannerPricing.module.scss"

const BannerPricing = props => {
  return (
    <BannerContainer
      renderLeftWrapperChildren={() => {
        return (
          <React.Fragment>
            <div
              className={
                styles.contentWrapper + " pr-lg-10 text-center text-lg-left"
              }
            >
              <TopTitle
                content="PRIVACY POLICY"
                className={styles.topTitle}
                removeBottomSpace={true}
              />
              <AnchorButton
                href="/demo"
                content="SEE A DEMO"
                className={styles.button}
              />
            </div>

            <div className={styles.emptyBlockLeft + " w-100 bg-white"}></div>
          </React.Fragment>
        )
      }}
      rightClassName="align-items-center align-items-lg-end"
      renderRightWrapperChildren={() => {
        return (
          <React.Fragment>
            <WrapperInner className={styles.wrapperInnerRight + " pl-lg-10"}>
            </WrapperInner>
            <div className={styles.emptyBlockRight + " w-100 bg-white"}></div>
          </React.Fragment>
        )
      }}
    />
  )
}

export default BannerPricing
